import { Accordion, AccordionDetails, AccordionSummary, Divider, SxProps, Theme, Typography } from '@mui/material';
import { TypographyVariant } from '@mui/material';
import { Icons } from 'greener-ui-library';

type AccordionPanelProps = {
  children: React.ReactNode;
  contentStyles: React.CSSProperties;
  defaultExpanded?: boolean;
  divider?: boolean;
  title: string;
  titleVariant?: TypographyVariant;
  titleStyles?: React.CSSProperties;
  sx?: SxProps<Theme>;
};

export function AccordionPanel({
  children,
  contentStyles,
  defaultExpanded,
  divider = false,
  title,
  titleVariant = 'h5',
  titleStyles,
  sx,
}: AccordionPanelProps) {
  return (
    <div>
      <Accordion defaultExpanded={defaultExpanded} sx={sx}>
        <AccordionSummary expandIcon={<Icons.ExpandMore />} sx={{ px: 3, height: '58px', ...titleStyles }}>
          <Typography variant={titleVariant}>{title}</Typography>
        </AccordionSummary>
        {divider && <Divider />}
        <AccordionDetails
          sx={{
            ...contentStyles,
          }}
        >
          {children}
        </AccordionDetails>
      </Accordion>
    </div>
  );
}
